export enum RegionState {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    INDETERMINATE = 'INDETERMINATE',
}
